<script setup lang="ts">
import { User, MoreVertical } from 'lucide-vue-next';
import brandLogo from '@/assets/logo-brand.svg';
</script>

<template>
  <div class="home-state-container">
    <header class="app-header-main">
      <div class="header-inner">
        <div class="brand-logo-container">
          <img :src="brandLogo" alt="BetPic" class="brand-img" />
        </div>
        <div class="header-actions">
          <div class="user-pill"><User :size="16" /></div>
          <div class="more-btn"><MoreVertical :size="18" /></div>
        </div>
      </div>
    </header>

    <div class="scroller-content animate-in">
      <div class="search-box-home">
        <span class="placeholder">Type your bet...</span>
      </div>
      <div class="suggested-card">
        <h3 class="suggested-title">EXAMPLES</h3>
        <div class="suggested-items">
          <div class="s-item">Arsenal to win, Saka scores</div>
          <div class="s-item">Arsenal to win, at least 3 goals</div>
          <div class="s-item">Chelsea correct score 3-1</div>
          <div class="s-item">Bayern Munich to win, Kane to score</div>
          <div class="s-item">Haaland scores</div>
        </div>
      </div>
      <footer class="home-footer">
        <div class="footer-pills"><span>Contact Us</span><span>Privacy</span><span>Cookies</span></div>
        <div class="copy-text">© 2026 Voxbet</div>
      </footer>
    </div>
  </div>
</template>

<style scoped>
.home-state-container { display: flex; flex-direction: column; height: 100%; width: 100%; }
.app-header-main { padding: 4px 12px; height: 46px; z-index: 50; }
.header-inner { display: flex; justify-content: space-between; align-items: center; height: 100%; }
.brand-logo-container { display: flex; align-items: center; }
.brand-img { height: 20px; width: auto; object-fit: contain; }
.header-actions { display: flex; align-items: center; gap: 8px; }
.header-icon { color: #fff; font-size: 1.1rem; }
.user-pill { width: 28px; height: 28px; background: #e21b0d; border-radius: 50%; color: #fff; display: flex; align-items: center; justify-content: center; }
.more-btn { color: #fff; display: flex; align-items: center; }

.scroller-content { flex: 1; padding: 12px; display: flex; flex-direction: column; gap: 20px; overflow-y: auto; }
.search-box-home { background: #0c0c0e; border-radius: 100px; padding: 10px 16px; border: 1px solid #1a1a1c; color: #555; font-size: 13px; }
.suggested-card { background: #111113; border-radius: 16px; padding: 20px; }
.suggested-title { font-size: 10px; font-weight: 800; color: #666; text-align: center; margin-bottom: 16px; letter-spacing: 1px; }
.suggested-items { display: flex; flex-direction: column; gap: 10px; }
.s-item { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.05); padding: 12px; border-radius: 100px; color: #ccc; font-size: 12px; text-align: center; font-weight: 500; }

.home-footer { margin-top: auto; padding-bottom: 8px; display: flex; flex-direction: column; align-items: center; gap: 10px; }
.footer-pills { display: flex; gap: 8px; }
.footer-pills span { background: #222; color: #aaa; padding: 5px 12px; border-radius: 100px; font-size: 10px; font-weight: 500; }
.copy-text { color: #444; font-size: 9px; }

.animate-in { animation: fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
</style>
